import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { LocalService } from "app/services/local.service";
import { environment } from "environments/environment";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class ProductsService {
  apiUrl = "";
  // JSON.parse(localStorage.getItem("client"))["apiUrl"] || environment.apiUrl;

  constructor(
    private http: HttpClient,
    public localService: LocalService,
  ) {
    if (localStorage.getItem("client")) {
      this.apiUrl = JSON.parse(localStorage.getItem("client"))["apiUrl"];
    } else {
      this.apiUrl = environment.apiUrl;
    }
  }
  getProducts(search): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .post(this.apiUrl + "inventory/getProductBySellerAggregator/", search, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  // Auto Complete Search for Products

  getProductsName(term: string) {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .get(this.apiUrl + "inventory/searchProduct?SearchString=" + term, {
        headers: headers,
      })
      .pipe(
        map((response) =>
          response["Data"]
            .filter((option) => {
              return (
                option.productName.toLowerCase().indexOf(term.toLowerCase()) >
                -1
              );
            })
            .slice(0, 10),
        ),
      );
  }

  getProductName(productName, sellerID) {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .post(
        this.apiUrl + "inventory/getProductBySellerAggregator/",
        { productName: productName, sellerID: sellerID },
        {
          headers: headers,
        },
      )
      .pipe(
        map((response) =>
          response["Data"]
            .filter((option) => {
              return (
                option.productName
                  .toLowerCase()
                  .indexOf(productName.toLowerCase()) === 0
              );
            })
            .slice(0, 10),
        ),
      );
  }
  getServiceName(serviceName, categoryID) {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .post(
        this.apiUrl + "service/list",
        { serviceName: serviceName, category: categoryID },
        {
          headers: headers,
        },
      )
      .pipe(
        map((response) =>
          response["Data"]
            .filter((option) => {
              return (
                option.serviceName
                  .toLowerCase()
                  .indexOf(serviceName.toLowerCase()) > -1
              );
            })
            .slice(0, 10),
        ),
      );
  }
    getProductSubCategories(id: { search: { categoryId: string } }) {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .post(this.apiUrl + "inventory/getSubCategoriesDetails", id, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
    }
    getMenuList(data): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .post(this.apiUrl + "inventory/menuLabel/list", data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }
    searchProductsName(data): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(this.apiUrl + "inventory/searchProductName", data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }
    getProductByIdV2(productId: any): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .get(this.apiUrl + "inventory/product/details/" + productId, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  deleteProduct(productId: string): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .delete(
        this.apiUrl + "inventory/removeProduct?productID=" + productId,
        {
          headers: headers,
        }
      )
      .map((response) => response)
      .toPromise();
  }

    postRequest(path,functionName,data) : Promise<any>{
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .post(this.apiUrl + path+"/"+functionName, data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }
    createProductV2(data): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(this.apiUrl + "inventory/product/create", data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }
    updateProductV2(data, recordId: string): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(this.apiUrl + "inventory/product/update/" + recordId, data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }
  /**
   * Addon apis
   */
  createAddon(data): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(this.apiUrl + "inventory/addon/create/", data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }
  listAddon(data): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(this.apiUrl + "inventory/addon/list/", data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }
  searchAddon(data) {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(this.apiUrl + "inventory/addon/list/", data, {
        headers: headers,
      })
      .pipe(map((response) => response["Data"]));
  }
  updateAddon(id, data): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .post(this.apiUrl + "inventory/addon/update/" + id, data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }
  deleteAddon(id, data): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .post(this.apiUrl + "inventory/addon/delete/" + id, data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }
  getAddonDetails(id): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .get(this.apiUrl + "inventory/addon/details/" + id, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }
  updateProductStatus(recordId: string, data): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(
        this.apiUrl +
          "inventory/updateProductStatus?productID=" +
          recordId,
        data,
        {
          headers: headers,
        }
      )
      .map((response) => response)
      .toPromise();
  }

  // ================= STOCK PROCESS =================
  stockProcess(data): Promise<any> {

  const headers = new HttpHeaders({
    "Content-Type": "application/json",
    "x-access-token": localStorage.getItem("token"),
  });

  return this.http
    .post(this.apiUrl + "inventory/stockProcess", data, {
      headers: headers,
    })
    .map((response) => response)
    .toPromise();
}
// ================= TRANSACTION DETAILS =================
getTransactionDetails(data): Promise<any> {

  const headers = new HttpHeaders({
    "Content-Type": "application/json",
    "x-access-token": localStorage.getItem("token"),
  });

  return this.http
    .post(this.apiUrl + "inventory/transaction/getTransactionDtl", data, {
      headers: headers,
    })
    .map((response) => response)
    .toPromise();
}
// ================= SUPPLIER WISE STOCK =================
getSupplierWiseStock(data): Promise<any> {

  const headers = new HttpHeaders({
    "Content-Type": "application/json",
    "x-access-token": localStorage.getItem("token"),
  });

  return this.http
    .post(this.apiUrl + "inventory/supplierWiseStock", data, {
      headers: headers,
    })
    .map((response) => response)
    .toPromise();
}
}
